import * as React from "react";
import { supabase } from "@/lib/supabaseClient";
import { Button } from "@/components/ui/button";
import { getSessionAndMemberStatus } from "@/lib/authz";

export default function AuthStatus({ className = "" }) {
  const [loading, setLoading] = React.useState(true);
  const [email, setEmail] = React.useState(null);

  React.useEffect(() => {
    let alive = true;

    async function load() {
      try {
        const { session, isAnon, isMember } = await getSessionAndMemberStatus();

        if (!alive) return;

        if (session?.user && !isAnon && isMember) {
          setEmail(session.user.email ?? null);
        } else {
          setEmail(null);
        }
      } catch (e) {
        console.error(e);
        if (!alive) return;
        setEmail(null);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    }

    load();

    const { data: sub } = supabase.auth.onAuthStateChange(() => {
      load();
    });

    return () => {
      alive = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  async function handleSignOut() {
    await supabase.auth.signOut();
    // optional: hard refresh to clear UI state
    // window.location.href = "/";
  }

  if (loading) return null;
  if (!email) return null;

  return (
    <div className={`flex flex-col items-center gap-3 mx-auto text-center ${className}`}>
      <p className="text-sm font-sans text-black/60 my-4 text-center">Logged in as<br></br>{email}</p>
      <Button
        variant="outline"
        className="group text-sm font-sans rounded-xl items-center mx-auto border-none bg-black hover:bg-black px-8 hover:border-none text-[#ddd] hover:text-[#ddd]"
        onClick={handleSignOut}
      >
        Sign out
        <span className="inline-block ml-2 transition-transform duration-300 group-hover:translate-x-3">
      →
    </span>
      </Button>
    </div>
  );
}
